import {
  IonAlert,
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonRow,
  IonToolbar,
} from "@ionic/react";

import { arrowBackOutline, close } from "ionicons/icons";

import "./ReportDamageModal.css";

import Step1 from "./Step1";
import { useEffect, useState } from "react";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import { useLocation, useParams } from "react-router";
import { Preferences } from "@capacitor/preferences";
import { getVehicleParts, useGetVehiclePartQuery } from "../../api/vehicles";
import { createDamage } from "../../api/damage";
import { VehiclePart } from "../../types/api/vehiclePart.types";
import { dataURLtoFile } from "../../utils/utils";
import { createMedia } from "../../api/media";
import Step1Documents from "./Step1Documents";
interface ReportDamageModalProps {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
  selectSide?: string;
  setSelectSide: (value: string) => void;
  selectType?: string;
  setSelectType: (value: string) => void;
  initialStep?: number;
  setStep: (value: number) => void;
  step?: number;
  vehicleId: string;
  trailerId?: string;
  journeyId?: string;
}

const initCheckboxOptions = {
  grooves: false,
  impacts: false,
  twistedElement: false,
  pressedElement: false,
};
const ReportDamageModal: React.FC<ReportDamageModalProps> = ({
  isOpen,
  setOpen,
  selectSide = "front",
  setSelectSide,
  selectType = "front",
  setSelectType,
  step = 0,
  setStep,
  vehicleId,
  trailerId,
  journeyId,
}) => {
  const [selectedElement, setSelectedElement] = useState<string>("");
  const [damageList, setDamageList] = useState<{ [key: string]: boolean }>({});
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [vehicleParts, setVehicleParts] = useState<VehiclePart[] | null>();
  const [cameraIsActive, setCameraIsActive] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const location = useLocation();

  const isOnFinishPage = location.pathname.includes("finish");

  useEffect(() => {
    const updateVehicleParts = async () => {
      setVehicleParts(
        await getVehicleParts({
          page: "1",
          itemsPerPage: "50",
          type: selectType,
          vehicleSide: selectSide,
        })
      );
    };
    updateVehicleParts();
  }, [selectType, selectSide]);

  const storeDamage = async () => {
    let oldDamages: any[] =
      JSON.parse(
        (await Preferences.get({ key: "damages" }))?.value as string
      ) || [];

    let responseMedia = null;

    if (imageUrl && imageUrl !== "") {
      responseMedia = await createMedia({
        media: dataURLtoFile(imageUrl!, "photo.jpg"),
      });
    }

    let damageTypeIdArray = Object.entries(damageList)
      ?.filter(([key, value]) => value === true)
      ?.map(([key]) => key);

    //Case of adding damage before departure
    if (!journeyId) {
      let newDamages = damageTypeIdArray.map((damageTypeId) => ({
        vehicleId: vehicleId,
        journeyId: null,
        damageTypeId: damageTypeId,
        moment: "Avant départ",
        picture: responseMedia ? responseMedia?.id : "",
        comment: description,
      }));
      await Preferences.set({
        key: "damages",
        value: JSON.stringify([...oldDamages, ...newDamages]),
      });
    } else {
      damageTypeIdArray.forEach(async (damageTypeId) => {
        await createDamage({
          vehicleId:
            selectType === "Trailer" && trailerId ? trailerId : vehicleId,
          journeyId: journeyId,
          damageTypeId: damageTypeId,
          moment: "Après départ",
          picture: responseMedia ? responseMedia?.id : "",
          comment: description,
        });
      });
    }
  };

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const onPopState = (e: PopStateEvent) => {
      window.history.pushState(null, "", window.location.href);

      if ((isOnFinishPage && step === 4) || (!isOnFinishPage && step === 0)) {
        setOpen(false);
        setStep(step);
        setDescription("");
        setSelectedElement("");
        setDamageList(initCheckboxOptions);
        setImageUrl("");
      } else if (
        (isOnFinishPage && step === 0) ||
        (isOnFinishPage &&
          step === 1 &&
          (selectSide === "Inside" || selectSide === "TrailerInside"))
      ) {
        setStep(4);
      } else {
        setStep(step - 1);
      }
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [history, step]);

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => setOpen(false)}
      className="ReportDamageModal-modal"
    >
      <IonAlert
        isOpen={confirmModalIsOpen}
        header="Êtes vous sur ?"
        message="Vous allez quitter la signalisation de dommage de votre véhicule, êtes vous sûr ?"
        className="Breadcrumb-alert"
        buttons={[
          {
            text: "Annuler",
            role: "cancel",

            handler: () => {
              setConfirmModalIsOpen(false);
            },
          },
          {
            text: "OK",
            role: "confirm",
            handler: () => {
              setOpen(false);
              setDescription("");
              setSelectedElement("");
              setDamageList(initCheckboxOptions);
              setImageUrl("");

              if (isOnFinishPage) {
                setStep(4);
              } else if (
                selectSide === "TrailerInside" ||
                selectSide === "Inside"
              ) {
                setStep(1);
              } else {
                setStep(0);
              }
            },
          },
        ]}
        onDidDismiss={() => setConfirmModalIsOpen(false)}
      ></IonAlert>
      <div className="ReportDamageModal">
        <div className="ReportDamageModal-header">
          {(!isOnFinishPage &&
            step !== 0 &&
            selectSide != "Inside" &&
            selectSide != "TrailerInside") ||
          (isOnFinishPage && step !== 4) ? (
            <IonButton
              shape="round"
              className="ReportDamageModal-backButton"
              onClick={() => {
                if (
                  (isOnFinishPage && step === 0) ||
                  (isOnFinishPage &&
                    step === 1 &&
                    (selectSide === "Inside" || selectSide === "TrailerInside"))
                ) {
                  setSelectedElement("");
                  setStep(4);
                } else {
                  setStep(step - 1);
                }
              }}
            >
              <IonIcon slot="icon-only" icon={arrowBackOutline} />
            </IonButton>
          ) : null}
          <div className="ReportDamageModal-subtitle"> Nouveau dommage</div>
          <IonIcon
            icon={close}
            className="ReportDamageModal-icon_cross"
            onClick={() => {
              setConfirmModalIsOpen(true);
            }}
          />
        </div>

        <div>
          {step === 0 && selectSide === "Document" ? (
            <Step1Documents
              side={selectSide}
              type={selectType}
              setStep={setStep}
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
              vehicleParts={vehicleParts || []}
            />
          ) : step === 0 && selectSide !== "Document" ? (
            <Step1
              side={selectSide}
              type={selectType}
              setStep={setStep}
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
            />
          ) : step === 1 ? (
            <Step2
              side={selectSide}
              storeDamage={storeDamage}
              type={selectType}
              setStep={setStep}
              selectedElement={selectedElement}
              damageList={damageList}
              setDamageList={setDamageList}
              vehicleParts={vehicleParts || []}
              setOpen={setOpen}
              setSelectedElement={setSelectedElement}
              setImageUrl={setImageUrl}
              setDescription={setDescription}
            />
          ) : step === 2 ? (
            <Step3
              side={selectSide}
              type={selectType}
              setStep={setStep}
              selectedElement={selectedElement}
              damageList={damageList}
              description={description}
              setDescription={setDescription}
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              vehicleParts={vehicleParts || []}
              setCameraIsActive={setCameraIsActive}
              storeDamage={storeDamage}
              setOpen={setOpen}
              setSelectedElement={setSelectedElement}
              setDamageList={setDamageList}
            />
          ) : step === 3 ? (
            <Step4
              side={selectSide}
              type={selectType}
              setStep={setStep}
              selectedElement={selectedElement}
              damageList={damageList}
              description={description}
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              setOpen={setOpen}
              setSelectedElement={setSelectedElement}
              setDamageList={setDamageList}
              setDescription={setDescription}
              setSelectSide={setSelectSide}
              setSelectType={setSelectType}
              storeDamage={storeDamage}
              vehicleParts={vehicleParts || []}
              setCameraIsActive={setCameraIsActive}
            />
          ) : step === 4 ? (
            <Step5
              setStep={setStep}
              selectedElement={selectedElement}
              setSelectedElement={setSelectedElement}
              selectSide={selectSide}
              setSelectSide={setSelectSide}
              selectType={selectType}
              setSelectType={setSelectType}
            />
          ) : null}
        </div>
      </div>
    </IonModal>
  );
};

export default ReportDamageModal;
